// extracted by mini-css-extract-plugin
module.exports = {"search-stories-component-icon":"FqsVC"};